const SkeletonListCommunity = () => {
  return (
    <div className="mt-2 p-4 rounded-t-lg bg-white w-full max-w-md animate-pulse">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
        <div className="flex-1">
          <div className="h-4 bg-gray-300 rounded w-24"></div>
          <div className="h-3 bg-gray-300 rounded w-16 mt-1"></div>
        </div>
      </div>
      
      <div className="mt-3 space-y-2">
        <div className="h-3 bg-gray-300 rounded w-full"></div>
        <div className="h-3 bg-gray-300 rounded w-5/6"></div>
      </div>
      
      <div className="w-full h-40 bg-gray-300 rounded-lg mt-3 flex items-center justify-center">
      </div>
      
      <div className="flex justify-start mt-3">
        <div className="w-4 h-4 mr-1 bg-gray-300 rounded-full"></div>
        <div className="w-4 h-4 mr-1 bg-gray-300 rounded-full"></div>
        <div className="w-4 h-4 bg-gray-300 rounded-full"></div>
      </div>
    </div>
  );
};

export default SkeletonListCommunity;